import React from "react";
import AssetsTable from "./components/AssetsTable";

export default function Assets() {
  return (
    <div className="grid h-full min-h-0 grid-cols-1 gap-5">
      <AssetsTable />
    </div>
  );
}


